import { render, staticRenderFns } from "./daynamic.vue?vue&type=template&id=1472ed42&scoped=true"
import script from "./daynamic.vue?vue&type=script&lang=js"
export * from "./daynamic.vue?vue&type=script&lang=js"
import style0 from "./daynamic.vue?vue&type=style&index=0&id=1472ed42&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1472ed42",
  null
  
)

export default component.exports